import {Suspense, lazy} from 'react';
import {AppLayout} from "../layout/AppLayout.tsx";
import {ReportsLoading} from "./ReportsLoading.tsx";
import {PublicHomePage} from "../features/home/pages/PublicHomePage.tsx";
import {SignOutPage} from "../features/home/pages/SignOutPage.tsx";
import {ProductsLayout} from "../features/products/layout.tsx";
import {RatePlansLayout} from "../features/rate-plans/layout.tsx";
import {BillingProvidersLayout} from "../features/billing-providers/layout.tsx";

import {MetersLayout} from "../features/meters/layout.tsx";
import {MeterAssignmentsLayout} from "../features/meter-assignments/layout.tsx";
import {BillableEventsLayout} from "../features/billable-events/layout.tsx";
import {MeteringRecordsLayout} from "../features/metering-records/layout.tsx";
import {BindingDriftReconciliationLayout} from "../features/binding-drift-reconciliation/layout.tsx";
import {ReconciliationReportsLayout} from "../features/reconciliation-reports/layout.tsx";
import {UsageEventsLayout} from "../features/usage-events/layout.tsx";
import {PricesLayout} from "../features/prices/layout.tsx";
import {ProductFeaturesLayout} from "../features/product-features/layout.tsx";
import {ProviderMappingsLayout} from "../features/provider-mappings/layout.tsx";
import {ApplicationErrorPage} from "@flexinet/ui-components";
import {CustomersLayout} from "../features/customers/layout.tsx";
import {CustomerSubscriptionsLayout} from "../features/customer-subscriptions/layout.tsx";
import {DashboardLayout} from "../features/dashboard/layout.tsx";
import {InvoicesLayout} from "../features/invoices/layout.tsx";

// Lazy-loaded — keeps @mantine/charts + recharts (~166 kB gzip) out of the
// main bundle. Users only download the Reports chunk when navigating to /reports.
const ReportsLayout = lazy(() => import("../features/reports/layout.tsx"));


export const routesConfig = [{
    path: '/',
    element: <AppLayout/>,
    errorElement: <ApplicationErrorPage/>,
    children: [{
        index: true,
        element: <PublicHomePage/>
    }, {
        path: 'sign-out',
        element: <SignOutPage/>
    }, {
        path: 'dashboard',
        element: <DashboardLayout/>
    }, {
        path: 'products/*',
        element: <ProductsLayout/>
    }, {
        path: 'product-features/*',
        element: <ProductFeaturesLayout/>
    }, {
        path: 'prices/*',
        element: <PricesLayout/>
    }, {
        path: 'rate-plans/*',
        element: <RatePlansLayout/>
    }, {
        path: 'billing-providers/*',
        element: <BillingProvidersLayout/>
    }, {
        path: 'meters/*',
        element: <MetersLayout/>
    }, {
        path: 'meter-assignments/*',
        element: <MeterAssignmentsLayout/>
    }, {
        path: 'billable-events/*',
        element: <BillableEventsLayout/>
    }, {
        path: 'metering-records/*',
        element: <MeteringRecordsLayout/>
    }, {
        path: 'binding-drift-reconciliation/*',
        element: <BindingDriftReconciliationLayout/>
    }, {
        path: 'reconciliation-reports/*',
        element: <ReconciliationReportsLayout/>
    }, {
        path: 'usage-events/*',
        element: <UsageEventsLayout/>
    }, {
        path: 'customers/*',
        element: <CustomersLayout/>
    }, {
        path: 'customer-subscriptions/*',
        element: <CustomerSubscriptionsLayout/>
    }, {
        path: 'invoices/*',
        element: <InvoicesLayout/>
    }, {
        path: 'provider-mappings/*',
        element: <ProviderMappingsLayout/>
    }, {
        path: 'reports/*',
        element: (
            <Suspense fallback={<ReportsLoading/>}>
                <ReportsLayout/>
            </Suspense>
        )
    }]
}]